import React, { useId } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
import ButtonFieldLayout from '../../../../layouts/common/ButtonFieldLayout';

import s from './OpenForOrdersField.scss';

interface Props {
  fieldName: string;
  label: string;
  subLabel: string;
}

const OpenForOrdersField: React.FC<Props> = ({ fieldName, label, subLabel }) => {
  const id = useId();
  const { control } = useFormContext();
  const { field } = useController({ name: fieldName, control });

  return (
    <ButtonFieldLayout
      label={label}
      labelClassName={s['label']}
      labelProps={{ id: `${id}-label`, htmlFor: id }}
      subLabel={subLabel}
      subLabelClassName={s['sub-label']}
    >
      <div className={s['toggle-wrap']}>
        <MainToggle
          id={id}
          variant="main"
          size="medium"
          aria-labelledby={`${id}-label`}
          value={field.value}
          onChange={field.onChange}
        />
      </div>
    </ButtonFieldLayout>
  );
};
OpenForOrdersField.displayName = 'OpenForOrdersField';

export default OpenForOrdersField;
